const selectionDefaultBreakpoints = {
    431: {
        slidesPerView: 1.2,
        spaceBetween: 20,
    },
    467: {
        slidesPerView: 1.6,
        spaceBetween: 20,
    },
    567: {
        slidesPerView: 1.8,
        spaceBetween: 20,
    },
    768: {
        shortSwipes: false,
        slidesPerView: 3,
        spaceBetween: 28,
    },
    992: {
        shortSwipes: false,
        slidesPerView: 4,
        spaceBetween: 25,
    },
};

const selectionNarrowBreakpoints = {
    431: {
        slidesPerView: 1.2,
        spaceBetween: 20,
    },
    567: {
        slidesPerView: 1.8,
        spaceBetween: 20,
    },
    768: {
        shortSwipes: false,
        slidesPerView: 3,
        spaceBetween: 28,
    },
};

const accessoriesDefaultBreakpoints = {
    365: {
        slidesPerView: 1.45,
        spaceBetween: 8,
    },
    400: {
        slidesPerView: 1.65,
        spaceBetween: 8,
    },
    440: {
        slidesPerView: 1.85,
        spaceBetween: 8,
    },
    480: {
        slidesPerView: 2,
        spaceBetween: 8,
    },
    540: {
        slidesPerView: 2.3,
        spaceBetween: 8,
    },
    600: {
        slidesPerView: 2.6,
        spaceBetween: 8,
    },
    670: {
        slidesPerView: 3,
        spaceBetween: 8,
    },
    730: {
        slidesPerView: 3.3,
        spaceBetween: 8,
    },
    768: {
        shortSwipes: false,
        slidesPerView: 4,
        spaceBetween: 28,
    },
};

const accessoriesNarrowBreakpoints = {
    365: {
        slidesPerView: 1.45,
        spaceBetween: 8,
    },
    400: {
        slidesPerView: 1.65,
        spaceBetween: 8,
    },
    440: {
        slidesPerView: 1.85,
        spaceBetween: 8,
    },
    480: {
        slidesPerView: 2,
        spaceBetween: 8,
    },
    540: {
        slidesPerView: 2.3,
        spaceBetween: 8,
    },
    600: {
        slidesPerView: 2.6,
        spaceBetween: 8,
    },
    670: {
        slidesPerView: 3,
        spaceBetween: 8,
    },
    730: {
        slidesPerView: 3,
        spaceBetween: 8,
    },
    768: {
        shortSwipes: false,
        slidesPerView: 3,
        spaceBetween: 28,
    },
};

export {
    selectionDefaultBreakpoints,
    selectionNarrowBreakpoints,
    accessoriesDefaultBreakpoints,
    accessoriesNarrowBreakpoints,
};
